// Shade pages open on the "pack info" photo (weight / pieces / width) when the
// shopper arrives from the catalog, search or a link. A click on a colour swatch
// or texture lands on the colour photo instead — the gallery order stays
// colour → specs → the rest.
(() => {
  const FLAG = 'gva-shade-click';
  const PACK_ALT = 'per pack';

  // Mark navigation that starts inside the shade browser.
  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-gva-shade-browser] a[href], [data-gva-shade-browser] [data-texture]');
    if (!target) return;
    try { sessionStorage.setItem(FLAG, String(Date.now())); } catch (e) { /* storage blocked */ }
  }, true);

  let fromSwatch = false;
  try {
    const at = Number(sessionStorage.getItem(FLAG));
    sessionStorage.removeItem(FLAG);
    fromSwatch = at > 0 && Date.now() - at < 60000;
  } catch (e) { /* storage blocked */ }
  if (fromSwatch) return;

  const showSpecs = () => {
    const slider = document.querySelector('media-gallery slider-element');
    if (!slider) return true;
    const slides = Array.from(slider.querySelectorAll('.product__media'))
      .filter((slide) => slide.clientWidth > 0);
    const index = slides.findIndex((slide) => {
      const img = slide.querySelector('img');
      return img && (img.alt || '').toLowerCase().includes(PACK_ALT);
    });
    if (index <= 0) return true;              // no specs photo, or already first
    if (typeof slider.currentPage !== 'number' || !slider.itemOffset) return false;
    slider.select(index + 1, true);
    return true;
  };

  const start = () => {
    let tries = 0;
    const tick = () => {
      if (showSpecs() || ++tries > 60) return;
      setTimeout(tick, 50);
    };
    tick();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
